/**
 * Custas processuais pagas pelo cliente (cartório, guias, etc.).
 * Não são dinheiro do escritório: ficam só na tela do processo, fora do Financeiro.
 * Mesma regra usada nos alertas de vencimento para separar "dívida do cliente" de "dívida do escritório".
 */
export function isClientCourtCost(entry: {
  entry_type?: string;
  category?: string | null;
  description?: string | null;
  case_id?: string | null;
  administrative_process_id?: string | null;
}): boolean {
  if (entry.entry_type !== 'despesa') return false;
  if (!entry.case_id && !entry.administrative_process_id) return false;
  const category = entry.category || '';
  const description = (entry.description || '').toLowerCase();
  return category === 'Cartório' || category === 'Custas Processuais (Cliente)' || description.includes('custas');
}
